module.exports = function() {
  return new Worker("/" + "download.worker.a70c42e60b23f1bb35b4.js");
};